export default __webpack_public_path__ + "static/04-qs-latam-large-d546bede10e3e02236199affe8dd4d37.svg";